import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

export const defaultNS = 'common';

void i18next
	.use(initReactI18next)
	.use(
		resourcesToBackend(async (language: string, namespace: string) => {
			return import(`./locales/${language}/${namespace}.json`);
		})
	)
	.init({
		debug: import.meta.env.MODE === 'development',
		fallbackLng: 'es',
		ns: [defaultNS],
		defaultNS
	});

export default i18next;
